import { ELEMENT_GROUPS } from './../utils';

const SpaceElementFields = {
  group: ELEMENT_GROUPS.LAYOUTS,
  label: 'Spacer',
  icon: 'ViewColumnsIcon',
  description: 'Adds an element that renders a space',
  properties: ['layout', 'margin']
};

export default SpaceElementFields;
